module.exports = __webpack_public_path__ + "img/23-11_ñuñoa.1faa872e.jpg";